export class ArchiveOrdersRequest {
  Wholesaler: number;
  Customer: number;
  InternalItemNumber: number;
  DeliveryNoteNumber: number;
  OrderId: number;
  DateTimeFrom: Date;
  DateTimeTo: Date;
}